<template>
  <div class="fixed z-30 text-xs text-right text-black text-opacity-50 pointer-events-none top-4 right-4">
    <div v-if="update" class="flex items-center justify-center space-x-4">
      <div>
        <div>{{ app.name }} v{{ update.version }} Available</div>
        <div v-if="downloaded">
          Update is ready to install. <a class="font-bold cursor-pointer pointer-events-auto text-gold-500" @click="installUpdate">Install Now</a>
        </div>
        <template v-else>
          <div v-if="progress" class="flex space-x-2 whitespace-nowrap">
            <span>Downloading... {{ parseInt(progress.percent) }}% @ {{ formatBytes(progress.bytesPerSecond) }}/s</span>
          </div>
        </template>
      </div>
      <svg v-if="!downloaded" class="w-6 h-6 animate-spin" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <circle
          class="opacity-25"
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          stroke-width="4"
        />
        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
      </svg>
      <CircleCheckIcon v-else />
    </div>
    <div v-else>
      {{ app.name }} v{{ app.version }}
    </div>
  </div>
</template>

<script>
import { ref } from 'vue'
import { CircleCheckIcon } from 'vue-tabler-icons'

export default {
  components: {
    CircleCheckIcon,
  },
  setup () {
    const app = ref({
      name: process.env.VUE_APP_NAME,
      version: process.env.VUE_APP_VERSION,
    })
    const update = ref(null)
    const progress = ref(null)
    const downloaded = ref(false)

    try {
      window.App.onUpdateAvailable((value) => {
        update.value = value
        console.info('[APP]', 'Update Available', value)
      })

      window.App.onUpdateProgress((value) => {
        progress.value = value
      })

      window.App.onUpdateDownloaded(() => {
        downloaded.value = true
      })

      console.info('[APP]', 'Checking for an update...')
    } catch {
      console.info('[APP]', 'Updater is disabled.')
    }

    const installUpdate = () => {
      console.info('[APP]', 'Restarting...')
      window.App.installUpdate()
    }

    const formatBytes = (bytes) => {
      if (bytes === 0) return '0 bytes'

      const sizes = ['bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
      const i = Math.floor(Math.log(bytes) / Math.log(1024))

      return Intl.NumberFormat('en-US', {
        style: 'decimal',
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      }).format(bytes / Math.pow(1024, i)) + ' ' + sizes[i]
    }

    return {
      app,
      update,
      progress,
      downloaded,
      installUpdate,
      formatBytes,
    }
  },
}
</script>
